<template>
  <v-btn
    v-if="showdownload"
    fab
    width="27"
    height="27"
    color="primary"
    elevation="0"
    class="btn_tippy vuetify--sacnite"
    :class="clase + (loading ? ' loading' : '')"
    :loading="loading"
    :title="$t('view.commons.download')"
    @click="download(clave || item)">
    <em class="fas fa-download" />
  </v-btn>
</template>
<script>
export default {
  name: "ButtonDownload"
  , props: {
    clave: {
      default: null
      , type: Number
    }
    , item: {
      default: null
      , type: Object
    }
    , showdownload: {
      default: true
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , clase: {
      default: null
      , type: String
    }
  }
  , methods: {
    download(clave) {
      this.$emit("download", clave);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/ButtonDownload.vue